import { CustomerDetail } from '@/features';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/customers/$customerId')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CustomerDetail />;
}
